import Vue from 'vue'
import Router from 'vue-router'
import TaskOverview from './components/TaskOverview.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'taskoverview',
      component: TaskOverview
    },
    {
      path: '/task/:apiKey/:id',
      name: 'task',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './components/Task.vue')
    }
  ]
})
